
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import SubscriptionPlans from './pages/SubscriptionPlans';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCancel from './pages/SubscriptionCancel';
import Navbar from './components/Navbar';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner large"></div>
        <p>Carregando aplicação...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="app">
        {user && <Navbar />}
        <main className="main-content">
          <Routes>
            <Route 
              path="/login" 
              element={!user ? <Login /> : <Navigate to="/profile" />} 
            />
            <Route 
              path="/register" 
              element={!user ? <Register /> : <Navigate to="/profile" />} 
            />
            <Route 
              path="/forgot-password" 
              element={!user ? <ForgotPassword /> : <Navigate to="/profile" />} 
            />
            <Route 
              path="/profile" 
              element={user ? <Profile /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/subscription-plans" 
              element={user ? <SubscriptionPlans /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/subscription" 
              element={user ? <Subscription /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/subscription-success" 
              element={user ? <SubscriptionSuccess /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/subscription-cancel" 
              element={user ? <SubscriptionCancel /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/" 
              element={<Navigate to={user ? "/profile" : "/login"} />} 
            />
            <Route 
              path="*" 
              element={<Navigate to={user ? "/profile" : "/login"} />} 
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
